import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind classes, resolving conflicts so the last one wins.
 * Use this instead of template-literal className concatenation.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * ISO timestamp -> compact relative label, e.g. `"2d ago"`, `"5h ago"`,
 * `"just now"` (spec 011 task 5.5, the project card's "memory updated …"
 * badge). Falls back to the raw ISO string if unparsable — never throws, so
 * an unexpected shape from the server degrades gracefully rather than
 * blanking the card.
 */
export function formatRelativeTime(iso: string): string {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso

  const diffSeconds = Math.round((Date.now() - date.getTime()) / 1000)
  if (diffSeconds < 60) return 'just now'

  const diffMinutes = Math.round(diffSeconds / 60)
  if (diffMinutes < 60) return `${diffMinutes}m ago`

  const diffHours = Math.round(diffMinutes / 60)
  if (diffHours < 24) return `${diffHours}h ago`

  const diffDays = Math.round(diffHours / 24)
  return `${diffDays}d ago`
}
